import React, { useMemo } from 'react';
import { SearchSelect, SelectProps } from '@travelity/form';
import { TimezoneName } from '@travelity/api';

export interface SelectTimezoneProps extends Omit<SelectProps, 'options'> {}

const SelectTimezone: React.FC<SelectTimezoneProps> = props => {
    const timezones = useMemo(() => {
        return Object.entries(TimezoneName).map(([, value]) => ({
            label: value,
            value,
        }));
    }, []);

    return <SearchSelect {...props} options={timezones} />;
};

export default SelectTimezone;
